/* eslint-disable max-params */
// internal-deps
import { AnalyticsContextValue } from "@swiggy-private/checkout-core";

// constants
import { SCREEN_NAME, CLICK_ACTIONS, IMPRESSION_ACTIONS } from "../constants";
import { formatePlanAction } from "@cart-client/analytics/helper";

export const impressionRemoveOfferBundleHalfCard = (
    impressionEvent: AnalyticsContextValue["impressionEvent"],
    isM2CFlow?: boolean,
    context?: string,
    isOneProgram?: string,
): void => {
    impressionEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: isM2CFlow
            ? IMPRESSION_ACTIONS.IMPRESSION_REMOVE_OFFER_BUNDLE_M2C_CONFIRM
            : formatePlanAction(IMPRESSION_ACTIONS.IMPRESSION_REMOVE_OFFER_BUNDLE_CONFIRM, isOneProgram),
        context,
    });
};

export const clickRemoveOfferBundleHalfCard = (
    clickEvent: AnalyticsContextValue["clickEvent"],
    context: string,
    value: string,
    isM2CFlow?: boolean,
    isOneProgram?: string,
): void => {
    clickEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: isM2CFlow
            ? CLICK_ACTIONS.CLICK_REMOVE_OFFER_BUNDLE_M2C_CONFIRM
            : formatePlanAction(CLICK_ACTIONS.CLICK_REMOVE_OFFER_BUNDLE_CONFIRM, isOneProgram),
        context,
        label: value,
    });
};

export const impressionActiveState = (
    impressionEvent: AnalyticsContextValue["impressionEvent"],
    context: string,
    isOneProgram?: string,
) =>
    impressionEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: formatePlanAction(IMPRESSION_ACTIONS.IMPRESSION_ACTIVE_STATE, isOneProgram),
        context,
    });

export const impressionNudgeWidget = (
    impressionEvent: AnalyticsContextValue["impressionEvent"],
    context: string,
    isOneProgram?: string,
) =>
    impressionEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: formatePlanAction(IMPRESSION_ACTIONS.IMPRESSION_NUDGE_WIDGET, isOneProgram),
        context,
    });

export const clickNudgeWidget = (
    clickEvent: AnalyticsContextValue["clickEvent"],
    context: string,
    value: string,
    isOneProgram?: string,
) =>
    clickEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: formatePlanAction(CLICK_ACTIONS.CLICK_NUDGE_WIDGET, isOneProgram),
        context,
        label: value,
    });

export const impressionInlineWidget = (
    impressionEvent: AnalyticsContextValue["impressionEvent"],
    context: string,
    isOneProgram?: string,
) =>
    impressionEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: formatePlanAction(IMPRESSION_ACTIONS.IMPRESSION_INLINE_WIDGET, isOneProgram),
        context,
    });

export const clickInlineWidget = (
    clickEvent: AnalyticsContextValue["clickEvent"],
    context: string,
    value: string,
    isOneProgram?: string,
) =>
    clickEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: formatePlanAction(CLICK_ACTIONS.CLICK_INLINE_WIDGET, isOneProgram),
        context,
        label: value,
    });

export const impressionOfferTooltipText = (
    impressionEvent: AnalyticsContextValue["impressionEvent"],
    isOneProgram?: string,
) =>
    impressionEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: formatePlanAction(IMPRESSION_ACTIONS.IMPRESSION_TOOLTIP_INFO_TEXT, isOneProgram),
    });
